import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';

type Props = {
  show: boolean;
};
type State = {};

export default class Loader extends Component<Props, State> {
  parentEl: Element;

  constructor(props: Props) {
    super(props);

    const el = document.getElementById('app-loader');
    if (el) {
      this.parentEl = el;
    } else {
      let div = document.createElement('div');
      div.setAttribute('id', 'app-loader');
      document.body.append(div);
      this.parentEl = div;
    }
  }

  render() {
    return ReactDOM.createPortal(
      <div
        className='loader'
        style={{ display: this.props.show ? 'flex' : 'none' }}></div>,
      this.parentEl
    );
  }
}
